import {Component, Input, OnChanges} from '@angular/core';
import {faCheck, faPlay, faXmark} from "@fortawesome/free-solid-svg-icons";
import {EditorComponent} from "ngx-monaco-editor-v2";
import {FormsModule} from "@angular/forms";
import { NgClass } from "@angular/common";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

export interface CodeResult {
  samplesRemaining: number,
  compileError: string[],
  cases: Case[]
}
interface Case {
  id: number,
  output: string[],
  expectedOutput: string[],
  input: string[],
  runtimeError: string[]
  correctness: boolean
}
@Component({
    selector: 'code-output',
    templateUrl: 'code-output.component.html',
    imports: [
    EditorComponent,
    FormsModule,
    NgClass,
    FaIconComponent
],
    styleUrls: ['code-output.component.css']
})
export class CodeOutputComponent implements OnChanges{
  @Input('theme') theme = 'vs-light';
  @Input('result') result?: CodeResult = undefined
  editorOptions = {theme: this.theme, language: 'plaintext'};
  selectedCase?: Case = undefined
  selectedIndex = 0

  ngOnChanges() {
    if(this.result != undefined && this.result.cases.length > 0) {
      this.selectedCase = this.result.cases[0]
      this.selectedIndex = 0
    }
  }

  changeCase(c: Case, i: number) {
    this.selectedCase = c
    this.selectedIndex = i
    console.log(i)
    console.log(c)
  }

  protected readonly console = console;
  protected readonly faPlay = faPlay;
  protected readonly faCheck = faCheck;
  protected readonly faXmark = faXmark;
}
